import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Icon from 'flarum/common/components/Icon';
import { listCategories, saveCategory, deleteCategory } from '../../common/api';
export default class CategoryManagerModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "categories", []);
    _defineProperty(this, "newName", '');
    _defineProperty(this, "newColor", '#69c6b9');
    _defineProperty(this, "newIcon", '');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  load() {
    this.loading = true;
    listCategories().then(res => {
      this.categories = res.data || [];
      this.loading = false;
      m.redraw();
    });
  }
  className() {
    return 'CategoryManagerModal Modal--medium';
  }
  title() {
    return app.translator.trans('ernestdefoe-giveaways.forum.categories.manage_title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, this.loading ? m(LoadingIndicator, null) : m("div", {
      className: "CategoryManager"
    }, m("ul", {
      className: "CategoryManager-list"
    }, this.categories.map(c => {
      var _c$count;
      return m("li", {
        className: "CategoryManager-row",
        key: c.id
      }, m("input", {
        type: "color",
        className: "CategoryManager-color",
        value: c.color,
        oninput: e => {
          c.color = e.target.value;
        }
      }), m("input", {
        className: "FormControl CategoryManager-name",
        value: c.name,
        oninput: e => {
          c.name = e.target.value;
        }
      }), m("span", {
        className: "CategoryManager-iconPreview",
        "aria-hidden": "true"
      }, m(Icon, {
        name: c.icon || 'fas fa-tag'
      })), m("input", {
        className: "FormControl CategoryManager-icon",
        placeholder: "fas fa-tag",
        value: c.icon || '',
        oninput: e => {
          c.icon = e.target.value;
        }
      }), m("span", {
        className: "CategoryManager-count"
      }, (_c$count = c.count) != null ? _c$count : 0), m(Button, {
        className: "Button Button--icon Button--flat",
        icon: "fas fa-save",
        title: app.translator.trans('ernestdefoe-giveaways.forum.form.submit'),
        onclick: () => this.save(c)
      }), m(Button, {
        className: "Button Button--icon Button--flat CategoryManager-delete",
        icon: "fas fa-trash",
        title: app.translator.trans('ernestdefoe-giveaways.forum.delete'),
        onclick: () => this.remove(c)
      }));
    }), this.categories.length === 0 && m("li", {
      className: "CategoryManager-empty"
    }, app.translator.trans('ernestdefoe-giveaways.forum.categories.none'))), m("div", {
      className: "CategoryManager-add"
    }, m("h4", null, m(Icon, {
      name: "fas fa-plus"
    }), " ", app.translator.trans('ernestdefoe-giveaways.forum.categories.add')), m("div", {
      className: "CategoryManager-row"
    }, m("input", {
      type: "color",
      className: "CategoryManager-color",
      value: this.newColor,
      oninput: e => {
        this.newColor = e.target.value;
      }
    }), m("input", {
      className: "FormControl CategoryManager-name",
      placeholder: app.translator.trans('ernestdefoe-giveaways.forum.categories.name_placeholder'),
      value: this.newName,
      oninput: e => {
        this.newName = e.target.value;
      }
    }), m("span", {
      className: "CategoryManager-iconPreview",
      "aria-hidden": "true"
    }, m(Icon, {
      name: this.newIcon || 'fas fa-tag'
    })), m("input", {
      className: "FormControl CategoryManager-icon",
      placeholder: "fas fa-tag",
      value: this.newIcon,
      oninput: e => {
        this.newIcon = e.target.value;
      }
    }), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      loading: this.loading,
      onclick: () => this.add()
    }, app.translator.trans('ernestdefoe-giveaways.forum.categories.add'))))));
  }
  add() {
    if (!this.newName.trim()) return;
    this.loading = true;
    saveCategory({
      name: this.newName,
      color: this.newColor,
      icon: this.newIcon
    }).then(() => {
      var _this$attrs$onchange, _this$attrs;
      this.newName = '';
      this.newIcon = '';
      (_this$attrs$onchange = (_this$attrs = this.attrs).onchange) == null || _this$attrs$onchange.call(_this$attrs);
      this.load();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  save(c) {
    saveCategory({
      name: c.name,
      color: c.color,
      icon: c.icon
    }, c.id).then(() => {
      var _this$attrs$onchange2, _this$attrs2;
      (_this$attrs$onchange2 = (_this$attrs2 = this.attrs).onchange) == null || _this$attrs$onchange2.call(_this$attrs2);
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('ernestdefoe-giveaways.forum.saved'));
    });
  }
  remove(c) {
    if (!confirm(app.translator.trans('ernestdefoe-giveaways.forum.categories.confirm_delete'))) return;
    deleteCategory(c.id).then(() => {
      var _this$attrs$onchange3, _this$attrs3;
      (_this$attrs$onchange3 = (_this$attrs3 = this.attrs).onchange) == null || _this$attrs$onchange3.call(_this$attrs3);
      this.load();
    });
  }
}
flarum.reg.add('ernestdefoe-giveaways', 'forum/components/CategoryManagerModal', CategoryManagerModal);